import React from 'react';
import PlayArrow from '@material-ui/icons/PlayArrow';
import Stop from '@material-ui/icons/Stop';
import Refresh from '@material-ui/icons/Refresh';
import { ActionMenu } from '../ActionMenu';
import {
  ProjectCodeActionMenuItems,
  ProjectCodeAction,
  ProjectCodeActionType,
  ProjectCodeResourceType,
} from './types';

interface ProjectCodeMenuProps {
  handleActionClick: (
    action: ProjectCodeActionType,
    service: ProjectCodeResourceType,
  ) => void;
  handleMenuClose: () => void;
  handleOpenConnection: () => void;
  menuPosition: { mouseX: number | null; mouseY: number | null };
  service: ProjectCodeResourceType;
}

const getMenuItems = (
  service: ProjectCodeResourceType,
): ProjectCodeActionMenuItems[] => {
  switch (service) {
    case 'all': {
      return [
        {
          action: ProjectCodeAction.START,
          service: 'all',
          icon: <PlayArrow fontSize="small" color="primary" />,
          text: 'Start All',
          disabled: false,
        },
        {
          action: ProjectCodeAction.STOP,
          service: 'all',
          icon: <Stop fontSize="small" color="secondary" />,
          text: 'Stop All',
          disabled: false,
        },
        {
          action: ProjectCodeAction.RESTART,
          service: 'all',
          icon: <Refresh fontSize="small" color="primary" />,
          text: 'Restart All',
          disabled: false,
        },
      ];
    }
    default:
      return [];
  }
};

export const ProjectCodeActionMenu: React.FC<ProjectCodeMenuProps> = ({
  handleActionClick,
  handleMenuClose,
  menuPosition,
  service,
}) => {
  const menuItems = getMenuItems(service);

  return (
    <ActionMenu<{
      action: ProjectCodeActionType;
      service: ProjectCodeResourceType;
    }>
      handleActionClick={handleActionClick}
      handleMenuClose={handleMenuClose}
      menuPosition={menuPosition}
      menuItems={menuItems}
    />
  );
};
